import { render, staticRenderFns } from "./complaintList.vue?vue&type=template&id=6b803610&scoped=true&"
import script from "./complaintList.vue?vue&type=script&lang=js&"
export * from "./complaintList.vue?vue&type=script&lang=js&"
import style0 from "./complaintList.vue?vue&type=style&index=0&id=6b803610&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b803610",
  null
  
)

export default component.exports